export default __webpack_public_path__ + "static/media/Rectangle 96.9f3b2139.png";